<template>
  <main v-loading="pageLoading">
    <section class="order_info">
      <figure class="desc">
        <i class="icon-gou"></i>
        <p>
          <span>订单提交成功，请您尽快付款！ 订单号：<b>{{ info[0].orders_sn }}</b></span>
          <span>请在<strong>2小时内</strong>完成订单支付， 否则订单会自动取消。</span>
        </p>
      </figure>
      <div class="price">
        <p><span>应付金额：</span><b>{{ Number(info[0].total_amount) }}</b></p>
        <strong :class="{ open: showTable }" @click="showTable = !showTable">订单详情</strong>
      </div>
      <el-table :data="info" v-show="showTable">
        <el-table-column prop="hotel_name" label="酒店名称"></el-table-column>
        <el-table-column align="center" prop="created_at" label="下单时间"></el-table-column>
        <el-table-column align="center" prop="CheckInDate" label="入住时间"></el-table-column>
        <el-table-column align="center" prop="day" label="入住天数"></el-table-column>
        <el-table-column align="center" prop="total_amount" label="预订价格"></el-table-column>
      </el-table>
    </section>
    <section class="pay">
      <h3>支付方式</h3>
      <label>
        <el-radio v-model="payType" :disabled="true" label="0">余额支付</el-radio>
        <el-radio v-model="payType" label="1">第三方支付</el-radio>
      </label>
      <ul class="user" v-show="payType === '0'">
        <li>
          <span>账户余额：</span><b>0.00元</b>
          <strong>余额不足，请先<router-link :to="{ path: './' }">充值</router-link></strong>
        </li>
        <li>
          <span>支付密码：</span>
          <el-input disabled="" type="password" size="small" v-model="test"></el-input>
          <strong>请先设置支付密码，<router-link :to="{ path: './' }">点击设置</router-link>跳至设置支付密码页面</strong>
        </li>
      </ul>
      <nav v-show="payType === '1'" class="otherPay">
        <a 
          :class="{ on: payOption === 'zfb' }"
          @click="updatePayType"><img src="@assets/img/zhifubao.png" alt=""></a>
        <a 
          :class="{ on: payOption === 'wx' }"
          @click="payOption = 'wx'"><img src="@assets/img/weixinzhifu.png" alt=""></a>
      </nav>
      <div class="qrcode" v-loading="loading" :class="{ pay_success: payState }">
        <vue-qrcode :value="`${ payOption === 'wx' ? 'https://h5.cstravel.cn/api/v2/Yspay/wxJs?order_type=hotel&order_sn='+info[0].orders_sn : alipayUrl }`" :options="{ width: 200 }"/>
        <p>手机扫码进行支付</p>
      </div>
    </section>
  </main>
</template>

<script>
import $visa from '@api/visa';
import VueQrcode from 'vue-qrcode'
export default {
  components: {
    VueQrcode
  },
  data () {
    return {
      pageLoading: true,
      info: [{}],
      showTable: false,
      payType: '1',
      payOption: 'wx',
      alipayUrl: null,
      payState: false,
      loading: false, // 支付方式loading

      test: ''
    }
  },
  created () {
    const { orderNo } = this.$route.query;
    if ( !orderNo ) {
      this.$router.push('hotel');
      return;
    }
    this.getDetail(orderNo);
    this.listenPayResult(orderNo);
  },
  methods: {
    async updatePayType () {
      const { payOption, info } = this;
      const { orderNo } = this.$route.query;
      if ( payOption !== 'zfb' ) {
        this.loading = true;
        this.payOption = 'zfb';
        const res = await this.$axios.get('/Yspay/request', { params: { payment_type: 'YspayAlipay', order_type: 'hotel', order_sn: orderNo } });
        this.alipayUrl = res.source_qr_code_url;
        this.loading = false;
      }
    },
    async getDetail (orderNo) {
      // $visa.detail(orderNo).then(res => this.info = [res]);
      const info = await this.$axios.get(`/hotelOrders/getOrderByUser?order_sn=${orderNo}`);
      this.info = [info];
      this.pageLoading = false;
    },
    listenPayResult (orderNo) {
      if ( this.$route.name !== 'order_pay' ) { return; }
      $visa.payResult(orderNo).then(({ isPaid }) => {
        switch (isPaid) {
          case 0: {
            setTimeout(() => {
              this.listenPayResult(orderNo);
            }, 2000);
            break;
          }
          case 1: {
            this.$message.success('支付成功！');
            this.payState = true;
            setTimeout(() => {
              this.$router.push({ name: 'order_list' });
            }, 3000);
            break;
          }
        }
      })
    }
  }
}
</script>

<style scoped src="./pay.css"> </style>